import { PathUtils } from '@unisporkal/utilities';
import { searchParameterAdapter } from 'app/adapters/shared/searchParameters/searchParametersAdapter';

const lastSearchCreativeAssetType = (gallery) => {
  if (gallery.isCreative()) {
    return gallery.searchParameters.mediatype
      ? gallery.searchParameters.mediatype
      : 'all';
  }
  return null;
};

const storeRecentSearch = (phrase, url) => {
  if (!phrase) {
    return;
  }

  const maxRecentSearches = 6;
  let recentSearches = {};
  try {
    recentSearches =
      JSON.parse(localStorage.getItem('search.recentSearches')) || {};
  } catch (error) {
    console.log(error);
  }

  delete recentSearches[phrase];
  recentSearches[phrase] = {
    phrase,
    url,
    date: Date.now(),
  };
  const keys = Object.keys(recentSearches).reverse();
  for (let i = maxRecentSearches; i < keys.length; i += 1) {
    delete recentSearches[keys[i]];
  }
  localStorage.setItem('search.recentSearches', JSON.stringify(recentSearches));
};

export const store = (gallery, toSearchQuery) => {
  const legacyParameters = gallery?.searchParameters || {};

  const queryParameters = toSearchQuery(
    searchParameterAdapter(legacyParameters)
  );

  // session storage
  sessionStorage.previous_search_query = JSON.stringify(queryParameters);

  // local Storage
  localStorage['search.lastSearchParameters'] =
    PathUtils.encodeQueryParams(queryParameters);
  localStorage['search.lastSearchCreativeAssetType'] =
    lastSearchCreativeAssetType(gallery);

  // Store the last selected PA filter to be used by asset detail for spectrum tracking
  localStorage['search.lastSearchPAFilter'] = gallery.selectedPAId();

  localStorage.target_search_mix =
    window.tracking_data?.gallery_data.target_search_mix;

  if (!gallery.isAssetIdSearch()) {
    storeRecentSearch(gallery.searchParameters.phrase, window.location.url);
  }
};
